/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartRadar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2a3 3 0 0 1 2.99 3.257l1.853.658A3 3 0 1 1 20 10.83v2.342a3 3 0 1 1-3.157 4.914l-1.854.657A3 3 0 1 1 11 16.171v-1.342a3 3 0 1 1 2 0v1.342c.443.157.837.414 1.157.744l1.854-.658A3.002 3.002 0 0 1 18 13.17v-2.342a3.002 3.002 0 0 1-1.99-3.087l-1.854-.657C13.61 7.649 12.847 8 12 8s-1.611-.35-2.157-.915l-1.854.658a3 3 0 1 1-.832-1.828l1.854-.657A3 3 0 0 1 12 2zm0 16a1 1 0 1 0 .001 2.001A1 1 0 0 0 12 18zm7-3a1 1 0 1 0 .001 2.001A1 1 0 0 0 19 15zm-7-4a1 1 0 1 0 .001 2.001A1 1 0 0 0 12 11zm7-4a1 1 0 1 0 .001 2.001A1 1 0 0 0 19 7zM5 7a1 1 0 1 0 .001 2.001A1 1 0 0 0 5 7zm7-3a1 1 0 1 0 .001 2.001A1 1 0 0 0 12 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartRadar as ChartRadar };
